import { useTranslation } from 'react-i18next';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
} from '@mui/material';

export default function CountryDropdown({
  id,
  labelText,
  value,
  onChange,
  error,
  disabled,
  errorMessage,
  helperTextStyle,
  name,
}) {
  const { t } = useTranslation();
  const labelId = id || 'country-label';
  return (
    <div className='custom-select'>
      <FormControl variant='standard' error={error} disabled={disabled}>
        <InputLabel id={labelId}>
          {labelText || t('common.labels.country')}
        </InputLabel>
        <Select
          id={id}
          labelId={labelId}
          value={value || ''}
          onChange={onChange}
          name={name || 'country'}
          className='full-width-elem'>
          <MenuItem value='CA'>{t('common.countries.canada')}</MenuItem>
          <MenuItem value='US'>{t('common.countries.unitedStates')}</MenuItem>
          <MenuItem value='PR'>{t('common.countries.puertoRico')}</MenuItem>
          {value && !['CA', 'US', 'PR'].includes(value) && (
            <MenuItem value={value}>{value}</MenuItem>
          )}
        </Select>
        <FormHelperText style={helperTextStyle}>{errorMessage}</FormHelperText>
      </FormControl>
    </div>
  );
}
